import { styled } from '@mui/styles';
import Timeline from '@mui/lab/Timeline';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        activityContainer: {
            paddingTop: '15px !important'
        },
        textContainer: {
            backgroundColor: `${theme.palette.primary.main} !important`, 
            padding: '15px 25px'
        },
        acivityText: {
            color: 'white', 
            fontWeight: '600 !important', 
            fontSize: '19px !important'
        }
    }),
);

export const StyledTimeline = styled(Timeline)(({ theme })=>({
    border: '1px solid #e8e8e8',
    padding: '30px 16px !important',
    '& .MuiTimelineOppositeContent-root': {
        maxWidth: '65px',
        height: '65px',
        padding: '0 6px 12px 6px',
        position: 'relative',
        bottom: '8px',
    },
    '& .MuiTimelineDot-root': {
        margin: '7px 0 7px 0',
        transform: 'matrix(0.71, -0.71, 0.71, 0.71, 0, 0)',
        borderRadius: 0,
        borderWidth: 0
    },

    '& .MuiTimelineSeparator-root': {
        margin: '0 10px 0 5px',
    },

    '& .MuiTimelineConnector-root': {
        backgroundColor: theme.palette.primary.main,
        width: 1
    }
}));

export default useStyles;